export const theme = {
  white: "#FFFFFF" as const,
  gray50: "#F9FAFB" as const,
  gray100: "#F3F4F6" as const,
  gray200: "#E5E6EB" as const,
  gray300: "#D1D3DB" as const,
  red100: "#FEE2E2" as const,
};
